import { render, staticRenderFns } from "./NavigationSection.vue?vue&type=template&id=534aadc0"
import script from "./NavigationSection.vue?vue&type=script&lang=js"
export * from "./NavigationSection.vue?vue&type=script&lang=js"
import style0 from "./NavigationSection.vue?vue&type=style&index=0&id=534aadc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports